import React, { useRef, useState, useEffect } from "react";
import classNames from "classnames";
import styles from "./StickyTableFooter.module.scss";

interface Props {
    sticky?: boolean;
    children: React.ReactNode;
    className?: string;
    borderless?: boolean;
}

export const StickyTableFooter: React.FC<Props> = ({
    sticky = true,
    children,
    className,
    borderless = false,
}) => {
    const stickyRef = useRef<HTMLDivElement>(null);
    const [isStuckBottom, setIsStuckBottom] = useState(true);

    const handleScroll = () => {
        if (stickyRef.current) {
            const rect = stickyRef.current.getBoundingClientRect();
            const isAtBottom = Math.abs(rect.bottom - window.innerHeight) < 1;
            setIsStuckBottom(isAtBottom);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div
            ref={stickyRef}
            className={classNames(styles.stickyTableFooter, className, {
                [styles.stuckBottom]: isStuckBottom,
                [styles.sticky]: sticky,
                [styles.borderless]: borderless,
            })}
        >
            {children}
        </div>
    );
};
